@if(isModalOpen){
<app-sequential-token-load-information (close)="toggleModal()" [commandId]="selectedId!">
</app-sequential-token-load-information>
}
<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-8 ps-5">
                <h2 class="col pb-2 title">
                    {{ "SEQUENTIALTOKENLOAD_TITLE" | translate }}
                </h2>
                <h6 class="col subtitle">{{ "SEQUENTIALTOKENLOAD_SUBTITLE" | translate }}</h6>
            </div>
            <div class="col-md-4 pe-5 d-flex justify-content-end align-items-center"
                [routerLink]="['/remote-command/sequential-token-load-setup']">
                @if (
                authService.isAuthorized([
                PermissionsEnum.Remotecommands_sequentialtokenload_execute,
                ])
                ) {
                <button class="button-add-device">
                    {{ "SEQUENTIALTOKENLOAD_TITLE" | translate }}
                </button>
                }
            </div>
        </div>
        <div class="row d-flex align-items-center g-0 m-0 p-0 mb-2">
            <div class="col-12 d-flex justify-content-start align-items-center flex-nowrap ps-4 pb-2 gap-3">
                <app-sort class="flex-shrink-0" (close)="onSortOption($event)"></app-sort>
                <app-status [statuses]="commandStatuses" class="flex-shrink-0" (close)="onStatusOption($event)"></app-status>
                <div class="datepicker-container-wrapper position-relative flex-shrink-0">
                    <div class="button-wrapper">
                        <div class="button">
                            <img alt="Date" src="assets/core/table-button/date.svg" />
                            <div class="button-text" (click)="toggleDatepicker()"
                                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                                    {{ selectedDate }}
                                </ng-container>
                                <ng-template #noDateSelected>
                                    <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                                </ng-template>
                            </div>
                            <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit"
                                src="assets/device/x.svg" (click)="clearDates()" />
                        </div>
                    </div>
                    @if (isDatepickerOpen) {
                    <div class="overlay" (click)="toggleDatepicker()"></div>
                    <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                        [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
                    }
                </div>
                <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
                    (searchChange)="searchChange($event)" class="d-flex flex-shrink-0"></app-search>
                <span *ngIf="selectedRows.length > 0" class="custom-color d-flex flex-shrink-0 align-items-center gap-2">
                    {{selectedRows.length}} Selected
                    <img alt="Clear" src="assets/device/x.svg" (click)="clearSelection()" title="Clear selection" />
                </span>
                <div *ngIf="selectedRows.length > 0 && hasFailedSelected() && authService.isAuthorized([PermissionsEnum.Remotecommands_sequentialtokenload_execute])"
                    class="button-wrapper-gray flex-shrink-0">
                    <div class="button" (click)="isBulkRetryModalOpen = true" title="Bulk Retry">
                        <svg-icon class="p-0" src="assets/device/refresh.svg"></svg-icon>
                    </div>
                </div>
            </div>
            <div class="row g-0 m-0 pt-3">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th class="ps-1">
                                <input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelected($event)"
                                    (click)="$event.stopPropagation()" class="form-check-input custom-checkbox" />
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_SERVICENAME" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_METERNO" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "COMMAND_SOURCE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DATE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "TIME" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "STATUS" | translate }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data; let i=index" (click)="handleRowClick(row.id)">
                            <td appIsNew [executedTime]="$any(row).startTime" [seconds]="dayInMs"></td>
                            <td class="ps-1" (click)="checkbox.click(); $event.stopPropagation()">
                                <input type="checkbox" [checked]="isRowSelected(row.id!)" [id]="'checkbox-' + row.id"
                                    (change)="toggleRowSelection(row)" (click)="$event.stopPropagation()"
                                    class="form-check-input custom-checkbox" #checkbox />
                            </td>
                            <td>
                                <span>{{ row.assetType }}</span>
                            </td>
                            <td>
                                <span>{{ row.serviceName }}</span>
                            </td>
                            <td>
                                <span (click)="clipboardService.copyToClipboard(row.meterNo!, $event, i)"
                                    class="copyable">
                                    {{ row.meterNo }}
                                    <span class="copy-tooltip"
                                        *ngIf="clipboardService.copiedText === i.toString()">{{"COPIED" | translate}}</span>
                                </span>
                            </td>
                            <td>
                                <span class="source-cell-container">
                                    <div class="source-text-wrapper">
                                        <span class="source-text">{{ row.source }}</span>
                                    </div>
                                    <div *ngIf="(row.failCount || 0) > 0" class="source-icon-wrapper">
                                        <svg-icon class="retry-status-icon"
                                            [src]="isMaxCommandReached(row) ? 'assets/settings/red-exclamation.svg' : 'assets/settings/yellow-exclamation.svg'"
                                            [title]="getCommandTooltipText(row)">
                                        </svg-icon>
                                    </div>
                                </span>
                            </td>
                            <td>
                                <span>{{ row.startTime | date: "EEE MMM dd yyyy" }}</span>
                            </td>
                            <td>
                                <span>{{ row.startTime | date: "shortTime" }}</span>
                            </td>
                            <td (click)="printResponseOfCommand($event, row)">
                                <div class="status-container">
                                    <span [ngClass]="{
                                        'status-pending': row.commandStatus === 'Pending',
                                        'status-completed': row.commandStatus === 'Success',
                                        'status-failed': row.commandStatus === 'Failed',
                                        'status-fatal-error': row.commandStatus === 'ErrorOccured'
                                    }">{{ row.commandStatus === 'ErrorOccured' ? ('FATAL_ERROR' | translate) : row.commandStatus }}</span>
                                    @if (row.commandStatus === 'Failed' && authService.isAuthorized([PermissionsEnum.Remotecommands_sequentialtokenload_execute])) {
                                        <svg-icon class="retry-icon ps-2" src="assets/device/refresh.svg"
                                            (click)="retryCommand($event, row)">
                                        </svg-icon>
                                    }
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
</div>

<app-confirm-dialog *ngIf="isBulkRetryModalOpen" titleKey="RETRY" question="SEQUENTIALTOKENLOAD_BULKRETRY_CONFIRM"
    (confirm)="confirmBulkRetry()" (cancel)="isBulkRetryModalOpen = false"></app-confirm-dialog>
